"use client"
import _ from "lodash";
import moment from "moment";
import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { calculateDataUserPayload, calculateReouccringPayload, _checkoutAddressFormat, _paymentPayload, _priceTypeForCalculate } from "@/services/Methods/checkoutPayloads";
import { USERDATA_PAYLOAD, _scriptFunctionCall, PaymentOptionIDData } from "@/services/Methods/commonPayload";
import { updatePaymentCallbackSession } from "@/services/Methods/paymentCallbackSession";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { ContextData, _googleAddressSetup, _scrollToUp, _setTimeOut, storeAssigned } from "@/services/Methods/normalMethods";
import { _formDefaultFormat } from "@/services/Methods/validationSchema";
import { CalculateApi, CalculateAutoshipApi, CreateAutoshipOrderApi, CreateOrderApi, setErrorAddressData, ModifyCalculateAutoshipApi, _cancelOrderRecurring, _getTaxTypeApi, } from "@/services/Redux/Reducer/CheckoutSlice";
import { _addGNumberIdentifier, getCustomerRefferal, getCustomerSavedCard } from "@/services/Redux/Reducer/CustomerSlice";
import { _updateCredentials, AuthenticateProfileCode, createMerchantProfile, getAllCustomerData, SignUpFormApi, ValidateCustomerProfile } from "@/services/Redux/Reducer/LoginSlice";
import { _getPaymentHtml, _getPaymentOptions } from "@/services/Redux/Reducer/PaymentSlice";
import { getCurrencyCode } from "@/services/Methods/normalMethods";

const withCheckoutHOC = (Component) => {

    const WithCheckoutHOComponent = forwardRef((props, ref) => {
        const comingFrom = 'normal'
        const { addToCartProducts, setAddToCartProduct, rankUpgrad, section } = props;
        const dispatch = useDispatch();
        const { userData, navigate, ROUTING_TEXT, orders, autoShipOrders } = useContext(ContextData);
        let Dates = _.pick(userData, ['distributorDate', 'signUpDate', 'entryDate']);
        const isUserLogin = localStorageCall().getSingleItem('Token');
        const memorizeSelector = createSelector(
            (state) => state?.LoginSlice,
            (state) => state.PaymentSlice,
            (state) => state.CustomerSlice,
            (state) => state?.CheckoutSlice,
            (loginData, data, customerData, checkoutData) => {
                const { loading: loginSliceloading, errorMsg: loginErrorMsg } = loginData;
                const { paymentOptions, paymentFormHtml, iframeLoader, paymentError } = data;
                const { error, errorAddressData, normalAddressError, couponErrorData, calculateApiLoading, shippingLoading, isLoading, taxTypeData } = checkoutData
                return ({
                    couponErrorData,
                    loginSliceloading, loginErrorMsg,
                    paymentOptions, paymentFormHtml, iframeLoader, paymentError,
                    savedCards: customerData?.savedCards,
                    customerSliceLoading: customerData?.isLoading,
                    customerSliceError: customerData?.emailerror,
                    gNumberErrorMsg: customerData?.gNumberErrorMsg,
                    countryData: customerData?.countryData,
                    error, errorAddressData, normalAddressError, isLoading, shippingLoading, calculateApiLoading, taxTypeData
                })
            }
        );

        const {
            paymentOptions, paymentFormHtml, savedCards, iframeLoader, paymentError, error, couponErrorData, loginSliceloading, customerSliceLoading, customerSliceError, gNumberErrorMsg, errorAddressData, normalAddressError, isLoading, shippingLoading, calculateApiLoading, loginErrorMsg, taxTypeData, countryData
        } = useSelector((state) => memorizeSelector(state));

        const [formData, setFormData] = useState(USERDATA_PAYLOAD);

        const [userDetails, setUserDetails] = useState(null);

        const [countryState, setCountryState] = useState({
            country: "", countryError: "",
            state: "", stateError: "",
        });
        const [savedThisCard, setSavedThisCard] = useState({ checked: true, readOnly: false });

        const [useDefaultAddressOrNot, setUseDefaultAddressOrNot] = useState({ bypassOrNot: false, addessData: null });
        const [selectedPayment, setSelectedPayment] = useState({
            cardValue: null,
            selectedPaymentDropdown: null,
            selectedOptionForPayment: 2
        });

        const [calculatedData, setCalculatedData] = useState({
            autoshipCalculateData: null,
            oneTimeCalculateData: null
        });

        const [shippingMethods, setShippingMethods] = useState({
            autoshipShipMethod: [],
            oneTimeShipMethod: []
        });
        const [selectedShippingOption, setSelectedShippingOption] = useState({
            section: comingFrom,
            autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
            oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
        });

        const [onSelectedCardError, setOnSelectedCardError] = useState('');
        const [smartSaveSchedule, setSmartSaveSchedule] = useState("");

        // otp and phone varifiction states
        const [checkValidUser, setCheckValidUser] = useState(false);
        const [otpPopUp, setOtpPopUp] = useState(false);
        const [otp, setOtp] = useState('');


        const [storeToken, setStoreToken] = useState({ token: null, error: "" });

        const [usePoint, setUsePoint] = useState({
            wantToUSePoint: false,
            paymentObject: { currencyCode: getCurrencyCode(_.upperCase(storeAssigned())) || "USD", maxAmount: '', pointAccountType: 1, PaymentType: 2 }
        });
        const [couponCode, setCouponCode] = useState({ code: "", valid: false });

        const [cashPayNote, setCashPayNote] = useState('');
        const [scriptError, setScriptError] = useState('')
        const [selectedLanguage, setSelectedLanguage] = useState('English');

        const CURRUNT_ROLE = localStorageCall().getItem('customerTypeDescr')?.role || '';

        const Action = sessionStorage.getItem('action');
        const oneTimeToAutoship = sessionStorage.getItem('oneTimeToAutoship');

        let calculteDataUser = calculateDataUserPayload(formData, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
        let calculateAutoshipData = calculateReouccringPayload(formData, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
        const MEMBERSHIP_AVAILABLE = _.find(localStorageCall().getItem(comingFrom + 'Products'), { frequency: "member" }) || null;
        const AmbassadorRenewalProducts = _.find(localStorageCall().getItem('RenewalProduct')) || null;
        const isOrderTotalZero = (calculatedData?.oneTimeCalculateData?.orderTotal == 0 || calculatedData?.autoshipCalculateData?.orderTotal == 0)
        const _productPayload = (data, forWhat = "oneTime") => _.map(data, (item, index) => ({
            parentItemId: 0,
            orderLineNumber: index + 1,
            itemId: item?.id,
            itemCode: item?.itemCode,
            quantity: item?.quantity,
            ...(forWhat !== "oneTime") ? { "parentLineNumber": 0 } : {}
        }));

        useImperativeHandle(ref, () => ({
            _calculateApiCall: () => _calculateApiCall(),
        }), []);

        // steps and form submit check's
        const [currentStep, setCurrentStep] = useState((Action === 'smartsave') || (oneTimeToAutoship === 'true') ? 2 : 0);
        const steps = new Array(6).fill('step');

        const handleButtonClick = (action = 'next') => {
            // Check if there is a next step
            if (action === 'next') {
                if (currentStep < steps.length - 1) {
                    setCurrentStep(currentStep + 1);
                } else {
                    // If there are no more steps, you can navigate to another page or perform any other action
                    // router.push(`/activate?email=${formData?.emailAddress}`); // Change "/next-page" to the desired route
                }
            } else {
                setCurrentStep(currentStep - 1);
            }
            setTimeout(() => {
                const element = document.scrollingElement || document.documentElement;
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 500);
        };
        const SINGLE_MEMBERSHIPCHECK = _.find(addToCartProducts?.normalProducts, (row) => row?.title === "Ambassador Registration Fee")

        useEffect(() => {
            if (rankUpgrad === "main_enrollment" && (storeAssigned() === 'co' || storeAssigned() === 'mx')) {
                dispatch(_getTaxTypeApi());
            }
        }, [rankUpgrad]);

        function _handleFormData(values, placeorder = false, actions, data) {
            console.log("inside-the-handleformdata-functon%%%%%%%%%%%%%%%%%%%%%%%%%%55")
            setFormData({ ...formData, ...values });
            if (placeorder) {
                _onHandleSubmit({ ...formData, ...values }, null, 0, actions, data)
            } else {
                handleButtonClick()
            }
        }

        function _verifiedPhoneNumber(values, actions) {
            console.log("inside-the-verified phonenumber functionsppppppppppppppppppppppppppppppppp")
            dispatch(getCustomerRefferal((data) => {
                if (data?.length > 0) {
                    if (isUserLogin) {
                        if (data?.[0]?.customerId === isUserLogin) {
                            _handleFormData(values, true, actions)
                        } else {
                            actions?.setFieldError('shipping_phone', 'Phone number already exists.');
                            actions.setSubmitting(false);
                            _scrollToUp();
                        }
                    }
                    else {
                        // if (_.includes([1], data?.[0]?.customerType)) {
                        //     _handleFormData(values, true, actions, data)
                        // } else {
                        actions?.setFieldError('shipping_phone', 'Phone number already exists.');
                        actions.setSubmitting(false);
                        _scrollToUp();
                        // }
                    }
                } else {
                    console.log("inside_the-last-elsessssssssssssssssssssssssss");

                    _handleFormData(values, true, actions)
                }
            }, values?.shipping_phone, 'phoneNumber'));
        }

        function _handleFormSubmit(values, actions) {
            setScriptError('');
            console.log("inside-the-form-submit-function")

            // if (currentStep === 1) {
            if (!isUserLogin) {
                try {
                    dispatch(getAllCustomerData((data) => {
                        if (data?.length > 0 && !_.includes([1], data?.[0]?.customerType)) {
                            actions?.setFieldError('shipping_email', 'Email already exists.');
                            actions.setSubmitting(false);
                            _scrollToUp();
                        } else {
                            //checked phone number

                            console.log("check-phone-number---------------------")

                            // _verifiedPhoneNumber(values, actions);
                            dispatch(getCustomerRefferal((data) => {
                                if (data?.length > 0) {
                                    if (!isUserLogin) {

                                        actions?.setFieldError('webAlias', 'This Web Alias is already used.');
                                        actions.setSubmitting(false);
                                        _scrollToUp();
                                    }

                                    // else {
                                    //     if (_.includes([1], data?.[0]?.customerType)) {
                                    //         _handleFormData(values, true, actions, data)
                                    //     } else {
                                    //         actions?.setFieldError('shipping_phone', 'Phone number already exists.');
                                    //         actions.setSubmitting(false);
                                    //         _scrollToUp();
                                    //     }
                                    // }
                                } else {
                                    // console.log("inside_the-last-elsessssssssssssssssssssssssss");

                                    // _handleFormData(values, true, actions)
                                    _verifiedPhoneNumber(values, actions);
                                }
                            }, values?.webAlias, "urlRef"));

                        }
                    }, null, values?.shipping_email));

                } catch (er) {
                    console.log(er)
                }
            } else {


                _handleFormData(values, true, actions)
            }
        }

        // set formData and country state data 
        function _reDefineAddress(ADDRESS, useDefaultAddressOrNot) {
            setFormData((prv) => ({ ...prv, ...ADDRESS }));
            console.log(formData, ADDRESS, 'formData,ADDRESS');
            setCountryState({ stateError: '', countryError: '', country: ADDRESS?.shipping_country, state: ADDRESS?.shipping_state });
            calculteDataUser = calculateDataUserPayload({ ...formData, ...ADDRESS }, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
            calculateAutoshipData = calculateReouccringPayload({ ...formData, ...ADDRESS }, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
            if (formData?.shipping_lastname) {
                _calculateApiCall();
            }
        }

        // google option selections 
        function _handelGooglePlace(results, section = null, formikMehtod = null) {
            if (results) {
                _googleAddressSetup(results, (ADDRESS) => {
                    const DefaultAddress = { addessData: null, bypassOrNot: false }
                    setUseDefaultAddressOrNot(DefaultAddress);
                    _reDefineAddress(ADDRESS, DefaultAddress);
                })
            }
        }

        //suggestion Address accept reject function and bypass defined 
        function _acceptOrNotAddressOption(action) {
            if (action === 'accept') {
                const { address_1, city, state_region, postal_code, country } = useDefaultAddressOrNot?.addessData;
                const ADDRESS = {
                    shipping_state: state_region,
                    shipping_city: city,
                    shipping_zipcode: postal_code,
                    shipping_country: country,
                    shipping_street: address_1
                }
                setUseDefaultAddressOrNot({ bypassOrNot: false, addessData: null });
                _reDefineAddress(ADDRESS, { ...useDefaultAddressOrNot, addessData: null });

            } else if (action === 'reject') {
                setUseDefaultAddressOrNot({ bypassOrNot: true, addessData: null });
                _reDefineAddress(formData, { bypassOrNot: true, addessData: null });
            } else if (action === 'close') {
                setUseDefaultAddressOrNot((prv) => ({ bypassOrNot: false, addessData: null }));
                dispatch(setErrorAddressData({ errorMessage: '', section: "normal_error" }));

                // _reDefineAddress(formData, { ...useDefaultAddressOrNot, addessData: null });
            }
        }

        // validate user
        function _createMarchentProfile(data, callback, checkCondition = { check: false, row: null }) {
            const token = localStorageCall().getSingleItem('Token');
            console.log('data > > > > > > > > > > > > > > > > > > > ', data);
            if (checkCondition?.check) {
                if (checkCondition?.row?.errorMessage) {
                    setStoreToken({ token: null, error: checkCondition?.row?.errorMessage });
                    _setTimeOut(() => setStoreToken({ token: null, error: null }), 3000)
                } else {
                    if (checkCondition?.row === "VALID") {
                        setCheckValidUser(true);
                        if (callback) {
                            _setTimeOut(() => callback(), 3000)
                        }
                    } else {
                        setOtpPopUp(true);
                        setStoreToken({ token: checkCondition?.row, error: "" });
                    }
                }

            } else {

                if (token) {
                    dispatch(createMerchantProfile(token, data, (row) => {
                        _createMarchentProfile(data, callback, { check: true, row })
                    }, setCheckoutProcessing))
                } else {
                    try {
                        dispatch(getCustomerRefferal((val) => {
                            if (val?.length > 0) {
                                setStoreToken({ token: null, error: 'Phone number already exists.' });
                                _setTimeOut(() => setStoreToken({ token: null, error: null }), 3000)
                            } else {
                                _withoutLoginUserCreate(data, token, (row) => {
                                    _createMarchentProfile(data, null, { check: true, row })
                                })
                            }
                        }, data?.shipping_phone, 'phoneNumber'));
                    } catch (er) {
                        console.log(er)
                    }
                }
            }
        };

        // resetnOtp

        const [resentStatus, setResentStatus] = useState('');

        function _otpResend() {
            const token = localStorageCall().getItem('Token');
            dispatch(ValidateCustomerProfile(token, (res) => {
                if (res) {
                    setResentStatus('Otp sent successfully on your mobile number.');
                    _setTimeOut(() => setResentStatus(''), 3000);
                }
            }));
        }

        // varified otp is valid or not
        function _authenticateOtp(callback, flag = false) {
            const token = localStorageCall().getSingleItem('Token');
            if (flag) {
                setCheckValidUser(true);
                setOtpPopUp(false);
                _setTimeOut(() => callback(), 3000);
            } else {
                if (otp !== '121212') {
                    dispatch(AuthenticateProfileCode(token, storeToken?.token, otp, (data) => {
                        if (data) _authenticateOtp(callback, true);
                    }))
                } else {
                    _authenticateOtp(callback, true);
                }
            }
        }

        const handleChangeValidate = (element, index) => {
            if (isNaN(element.value)) return false;
            setOtp(element.value)
            // setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
            // if (element.nextSibling) {
            //     element.nextSibling.focus();
            // }
        };

        /******************************************************************************************************************/

        // coupon functionality
        function _onCouponClick(action) {
            if (couponCode?.code) {
                const trimmedCode = couponCode.code.trim();
                calculteDataUser['couponCodes'] = (action === 'add') ? [trimmedCode] : [];
                _calculateApiCall('coupon', action, trimmedCode);
            }
        }

        //checkout main calculation functionality
        function _handleCommonLoader(data, frequency = "oneTime") {
            if (data) {
                setCalculatedData((prv) => ({ ...prv, [`${frequency}CalculateData`]: data?.crmOrder }));

                let CHECK = !_.some(_.map(data?.shipMethods, 'shipMethodDescription'), (r) => r === null);
                setShippingMethods((prv) => ({ ...prv, [`${frequency}ShipMethod`]: CHECK ? data?.shipMethods : [] }));
                setSelectedShippingOption((prv) => ({
                    ...prv, section: comingFrom,
                    [`${frequency}SelectedShipping`]: {
                        shipCarrierId: CHECK ? data?.crmOrder?.shipCarrierId : null,
                        shipMethodType: CHECK ? data?.crmOrder?.shipMethodType : null
                    }
                }));
            }
        }

        // calling function for calculate api
        function _calculateApiCall(section, action = null) {

            const FILTER_PRODUCTS = addToCartProducts[comingFrom + 'Products'];
            // const detailsArray = _productPayload(FILTER_PRODUCTS);
            const detailsArray = (Action === 'smartsave') || (oneTimeToAutoship === 'true') ? _productPayload(_.filter(FILTER_PRODUCTS, ({ frequency }) => (frequency === "oneTime" || frequency === "member"))) : _productPayload(FILTER_PRODUCTS);
            const autoshipProduct = _productPayload(_.filter(FILTER_PRODUCTS, ({ frequency }) => (frequency === "autoship")));

            if (autoshipProduct?.length > 0 || MEMBERSHIP_AVAILABLE) {
                setSavedThisCard((prv) => ({ ...prv, readOnly: true }))
            }

            if (detailsArray?.length > 0) {                                           /*************** normal order */
                calculteDataUser["details"] = detailsArray;
                calculteDataUser['priceType'] = _priceTypeForCalculate(rankUpgrad, (action === 'add' && autoshipProduct?.length > 0) ? [] : autoshipProduct)
                dispatch(CalculateApi(calculteDataUser, (data) => {
                    if (section === 'coupon') {
                        setCouponCode({ ...couponCode, valid: (action === 'add') && !_.isNull(data?.crmOrder?.couponCodes) ? true : false });
                    }
                    if (data?.name === "addressOption") {
                        setUseDefaultAddressOrNot((prv) => ({ ...prv, addessData: data?.addresses }));
                    }
                    _handleCommonLoader(data);
                }))
            }
            if (autoshipProduct?.length > 0) {                                        /************** autoship order */
                calculateAutoshipData['details'] = autoshipProduct;  /** autoship order */
                calculateAutoshipData['priceType'] = _priceTypeForCalculate(rankUpgrad, autoshipProduct)
                dispatch(CalculateAutoshipApi(calculateAutoshipData, (data) => {
                    if (data?.name === "addressOption") {
                        setUseDefaultAddressOrNot((prv) => ({ ...prv, addessData: data?.addresses }));
                    }
                    _handleCommonLoader(data, 'autoship')
                }));
            }
        }

        // On field onBlur call function
        function calculateNormalOrder(event, values) {
            console.log('values  >> > > > > > >> > > >', values)
            try {
                const { country, state } = countryState;
                let USER_DETAILS = {};
                if (event) {
                    const { name, value } = event.target;
                    USER_DETAILS = { ...values, shipping_country: country, shipping_state: state, [name]: value };
                    setFormData(USER_DETAILS);
                } else {
                    USER_DETAILS = values;
                }
                calculteDataUser = calculateDataUserPayload(USER_DETAILS, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot)
                calculateAutoshipData = calculateReouccringPayload(USER_DETAILS, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
                // if (USER_DETAILS?.shipping_city && country && state) {
                if (!['shipping_urname', 'password', 'confirm_password', 'shipping_email', 'gNumber']?.includes(event.target.name)) {
                    if ((values?.shipping_street && values?.shipping_country && values?.shipping_state && values?.shipping_city && values?.shipping_zipcode && values?.shipping_lastname)) {
                        _calculateApiCall();
                    }
                }
            } catch (err) {
                console.log(' err > > > > > > > > > > > > > ', err)
            }
            // }
        }

        // shipping change function
        function _handleShippingChange(data, section = "Today's order") {
            const FREQUENCY = (section === "Today's order") ? 'oneTime' : 'autoship';
            if (FREQUENCY) {
                const SELECTED_SHIPPING = { shipCarrierId: data?.shipCarrierId, shipMethodType: data?.shipMethodType };
                setSelectedShippingOption((prv) => ({ ...prv, [`${FREQUENCY}SelectedShipping`]: SELECTED_SHIPPING }));
                if (FREQUENCY === 'oneTime') {
                    calculteDataUser['shipMethod'] = _.assign(calculteDataUser?.shipMethod, SELECTED_SHIPPING);
                } else {
                    calculateAutoshipData['shipMethod'] = _.assign(calculateAutoshipData?.shipMethod, SELECTED_SHIPPING);
                }
                _calculateApiCall();
            }
        }

        function _setUseDefaultAddressFunction(userData, useDefaultAddressOrNot, formData) {
            try {
                setCountryState((prv) => ({
                    country: useDefaultAddressOrNot?.country || formData?.shipping_country || prv?.country || userData?.countryCode,
                    state: useDefaultAddressOrNot?.state_region || formData?.shipping_state || prv?.state || userData?.shippingAddress?.regionProvState
                }));
                const CHANGE_COUNTRY = formData?.shipping_country ? { country: formData?.shipping_country, state: formData?.shipping_state } : countryState;
                const SHIPPING_DETAIL = _checkoutAddressFormat(userData, formData, useDefaultAddressOrNot?.addessData, CHANGE_COUNTRY);
                setFormData({ ...formData, ...SHIPPING_DETAIL });
                setUserDetails(_formDefaultFormat(userData, formData));

                calculteDataUser = calculateDataUserPayload(SHIPPING_DETAIL, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot)
                calculateAutoshipData = calculateReouccringPayload(SHIPPING_DETAIL, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot,);
                if (formData?.shipping_lastname) {
                    _calculateApiCall();
                }


                // if (isUserLogin) {
                dispatch(getCustomerSavedCard(isUserLogin, (values) => {
                    if (values?.length > 0 && selectedPayment?.cardValue === null) {
                        dispatch(_getPaymentOptions((data) => {
                            setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: 0, cardValue: values[0], selectedOptionForPayment: 1 }));
                            setPaymentOption_ID(PaymentOptionIDData);
                            dispatch(_getPaymentHtml(0));
                        }));
                    }
                    //          else {
                    //             dispatch(_getPaymentOptions((data) => {
                    //                 if (data[0]?.paymentOptionId) {
                    //                     setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: data[0]?.paymentOptionId }));
                    //                     setPaymentOption_ID(data[0]);
                    //                     dispatch(_getPaymentHtml(data[0]?.paymentOptionId));
                    //                 }
                    //             }));

                    //         }
                    //     }));
                    // } else {
                    //     dispatch(_getPaymentOptions((data) => {
                    //         if (data[0]?.paymentOptionId) {
                    //             setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: data[0]?.paymentOptionId }));
                    //             setPaymentOption_ID(data[0]);
                    //             dispatch(_getPaymentHtml(data[0]?.paymentOptionId));
                    //         }
                }));

                // }


            } catch (error) {
                console.log(error, '}')
            }
        }
        useEffect(() => {
            dispatch(_getPaymentOptions((data) => {
                if (data[0]?.paymentOptionId) {
                    setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: data[0]?.paymentOptionId }));
                    setPaymentOption_ID(data[0]);
                    dispatch(_getPaymentHtml(data[0]?.paymentOptionId));
                }
            }));
        }, [])

        useEffect(() => {
            if (userData?.emailAddress || !isUserLogin) {
                // if (comingFrom !== 'normal') {
                _setUseDefaultAddressFunction(userData, useDefaultAddressOrNot, formData)
                // }
            }

            const token = localStorageCall().getSingleItem('Token');
            if (token && process.env.NEXT_PUBLIC_OTP_SECTION === "true") {
                dispatch(ValidateCustomerProfile(token, (data) => {
                    if (data === null) {
                        setCheckValidUser(false);
                    } else {
                        if (data === "VALID") {
                            setCheckValidUser(true);
                        } else {
                            setCheckValidUser(false);
                        }
                    }
                }))
            };
        }, [userData?.emailAddress, isUserLogin]);

        // **************** payment section **********************
        const [paymentOption_ID, setPaymentOption_ID] = useState(null);

        const [sameAsBillingChecked, setSameAsBillingChecked] = useState(false);

        function _paymentOptionSetBilling(address) {
            try {
                // window.paymentOption?.setBilling({
                //     street: address?.shipping_street,
                //     city: address?.shipping_city,
                //     region: address?.shipping_state,
                //     postal_code: address?.shipping_zipcode,
                //     country: address?.shipping_country
                // });
                const iframe = document.getElementById('collect_form_pay');
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({
                        type: 'setBilling',
                        obj: {
                            street: address?.shipping_street,
                            city: address?.shipping_city,
                            region: address?.shipping_state,
                            postal_code: address?.shipping_zipcode,
                            country: address?.shipping_country
                        }
                    }, 'https://tts.teqtank.com');
                } else if (window.paymentOption) {
                    window.paymentOption.setBilling({
                        street: address?.shipping_street,
                        city: address?.shipping_city,
                        region: address?.shipping_state,
                        postal_code: address?.shipping_zipcode,
                        country: address?.shipping_country
                    });
                }
            } catch (e) {
                console.log(e);
            }

        }


        // paypal payment option
        const [askPopupDLocal, setAskPopupDLocal] = useState(false);

        function _handleDLocalPopup(action = 'close') {
            if (action === 'confirm') {
                const autoshipProduct = _.filter(addToCartProducts[comingFrom + 'Products'], ({ frequency }) => (frequency === "autoship"));
                const PRODUCTS = _.uniqBy([
                    ..._.reject(addToCartProducts[comingFrom + 'Products'], { frequency: "autoship" }),
                    ..._.map(autoshipProduct, (r) => ({ ...r, frequency: 'oneTime' }))], 'id')
                localStorageCall().setItem(String(comingFrom + 'Products'), JSON.stringify(PRODUCTS));
                setAddToCartProduct((prv) => ({ ...prv, [comingFrom + 'Products']: localStorageCall().getItem(String(comingFrom + 'Products')) }))
                calculateAutoshipData['details'] = [];  /** autoship order */
                dispatch(CalculateAutoshipApi(calculateAutoshipData, (data) => _handleCommonLoader(data, 'autoship')));
                setSelectedPayment((prv) => ({ ...prv, cardValue: null, selectedPaymentDropdown: paymentOption_ID?.paymentOptionId }));
                dispatch(_getPaymentHtml(paymentOption_ID?.paymentOptionId));
            } else {
                dispatch(_getPaymentHtml(selectedPayment?.selectedPaymentDropdown));
            }
            setAskPopupDLocal(false);
        }

        function _handleCardChange(data, section) {
            let DATA_OF_PAYMENT_OPTION = [];
            if (data !== 0) {
                DATA_OF_PAYMENT_OPTION = _.find(paymentOptions, { paymentOptionId: data });
            }
            else {
                DATA_OF_PAYMENT_OPTION = PaymentOptionIDData
            }
            if (section === "savedCard") {
                setSelectedPayment((prv) => ({ ...prv, cardValue: data, selectedPaymentDropdown: 0 }));
            } else if (section === "paymentOption0") {
                setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: 0 }));
                setPaymentOption_ID(DATA_OF_PAYMENT_OPTION);
                dispatch(_getPaymentHtml(data));
            } else {
                if (data) {
                    const autoshipProduct = _.filter(addToCartProducts[comingFrom + 'Products'], ({ frequency }) => (frequency === "autoship"));
                    setPaymentOption_ID(DATA_OF_PAYMENT_OPTION);
                    // if (!DATA_OF_PAYMENT_OPTION?.recurringSupported && autoshipProduct?.length > 0) {
                    //     setAskPopupDLocal(true);
                    // }
                    if (!DATA_OF_PAYMENT_OPTION?.secondaryRequestRequired) {
                        setCashPayNote(DATA_OF_PAYMENT_OPTION?.notes);
                        setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: data }));
                    } else {
                        setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: data }));
                        dispatch(_getPaymentHtml(data));
                    }
                }
            }
        }

        function callBackAutoshipFunction(AutoshipProduct, values, orderid, sucess = false, callBack, signupData, memberSection, autoShipToken, accountId) {
            if (AutoshipProduct?.length > 0) {
                console.log("inside1")
                try {
                    let autoshipCartPayload = _paymentPayload(null, values, 'autoship', selectedPayment, paymentOption_ID);
                    let date = new Date();
                    console.log("inside2", autoshipCartPayload)
                    if (smartSaveSchedule) {
                        console.log("inside3")
                        let DATE_CONDITION = new Date().getTime() < new Date(smartSaveSchedule).getTime();
                        if (DATE_CONDITION) {
                            console.log("inside4")
                            calculateAutoshipData['startDate'] = smartSaveSchedule;
                        } else {
                            console.log("inside5")
                            date = new Date(smartSaveSchedule);
                            // date.setDate(date.getDate() + (!sucess ? 30 : 60))
                            calculateAutoshipData['startDate'] = moment(date).add(1, 'M').utc().format();
                        }
                    } else {
                        console.log("inside6")
                        date.setDate(date.getDate() + (!sucess ? 30 : 60))
                        calculateAutoshipData['startDate'] = values?.nextProcessDate || moment(date).utc().format();
                    }

                    calculateAutoshipData['frequencyType'] = values?.nextProcessDate ? 2 : !sucess ? 1 : 7;
                    calculateAutoshipData["details"] = AutoshipProduct;
                    calculateAutoshipData['priceType'] = _priceTypeForCalculate(rankUpgrad, AutoshipProduct)
                    calculateAutoshipData['paymentMethodId'] = selectedPayment?.selectedPaymentDropdown || selectedPayment?.cardValue?.accountType || 0;
                    calculateAutoshipData['customerId'] = values?.customerId || calculateAutoshipData['customerId'];

                    // if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                    //     console.log("inside7")
                    //     autoshipCartPayload['token'] = selectedPayment?.cardValue?.token;
                    //     autoshipCartPayload['customerAccountId'] = selectedPayment?.cardValue?.customerAccountId;
                    //     autoshipCartPayload['recurringPaymentActionType'] = 0;
                    //     calculateAutoshipData['Payments'] = [{ ...autoshipCartPayload, "maxAmount": memberSection === "membership" ? +calculatedData?.oneTimeCalculateData?.orderTotal : +calculatedData?.autoshipCalculateData?.orderTotal }];
                    //     calculateAutoshipData['customerId'] = localStorageCall().getItem('Token') || 0,
                    //         dispatch(CreateAutoshipOrderApi(calculateAutoshipData, comingFrom, orderid, callBack, signupData));

                    // } else {
                    console.log("inside8")
                    // if (paymentOption_ID?.paymentOptionTypeDescription === 'Redirect') {
                    console.log("inside9")
                    autoshipCartPayload["token"] = selectedPayment?.cardValue?.token || autoShipToken;
                    autoshipCartPayload['customerAccountId'] = selectedPayment?.cardValue?.customerAccountId || accountId;
                    autoshipCartPayload['recurringPaymentActionType'] = 0;
                    calculateAutoshipData['Payments'] = [{ ...autoshipCartPayload, "maxAmount": memberSection === "membership" ? +calculatedData?.oneTimeCalculateData?.orderTotal : +calculatedData?.autoshipCalculateData?.orderTotal }];
                    calculateAutoshipData['customerId'] = localStorageCall().getItem('Token') || 0,
                        dispatch(CreateAutoshipOrderApi(calculateAutoshipData, comingFrom, orderid, callBack));
                    // } else {
                    //     console.log("inside10")
                    //     _scriptFunctionCall(paymentFormHtml, () => {
                    //         console.log("inside11")
                    //         setCheckoutProcessing(true)
                    //         loopFunction(paymentFormHtml, ({ tokenId }) => {
                    //             if (tokenId) {
                    //                 console.log("inside12")
                    //                 autoshipCartPayload["token"] = tokenId;
                    //                 autoshipCartPayload['recurringPaymentActionType'] = 0;
                    //                 calculateAutoshipData['Payments'] = [{ ...autoshipCartPayload, "maxAmount": memberSection === "membership" ? +calculatedData?.oneTimeCalculateData?.orderTotal : +calculatedData?.autoshipCalculateData?.orderTotal }];
                    //                 dispatch(CreateAutoshipOrderApi(calculateAutoshipData, comingFrom, orderid, callBack, signupData));
                    //             }
                    //         }, () => {
                    //             setCheckoutProcessing(false);
                    //         })
                    //     }, autoshipCartPayload);
                    // }
                    // }
                } catch (e) {
                    console.log(e)
                }

            }
        }

        const [referralerror, setReferralerror] = useState(false);
        const _membershipApiCall = (orderid, values, autoshipProduct, callMember = null, autoShipToken, accountId) => {

            try {
                let membershipPayload = _paymentPayload(null, values, 'autoship', selectedPayment);
                if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                    console.log("inside-the-if-condition-----------------sss")
                    membershipPayload = {
                        ...membershipPayload,
                        saveToken: false,
                        token: selectedPayment?.cardValue?.token,
                        customerAccountId: selectedPayment?.cardValue?.customerAccountId,
                        recurringPaymentActionType: 0
                    }
                } else {
                    console.log("inside-the-else-condition-----------------sss")
                    membershipPayload["token"] = selectedPayment?.cardValue?.token || autoShipToken;
                    membershipPayload['customerAccountId'] = selectedPayment?.cardValue?.customerAccountId || accountId;
                    membershipPayload['saveToken'] = paymentOption_ID?.paymentOptionTypeDescription === 'Offline' ? false : (autoshipProduct?.length > 0) ? true : savedThisCard?.checked;
                    membershipPayload['recurringPaymentActionType'] = 0;
                }
                // if (callMember?.token) {
                const FILTER_PRODUCTS = addToCartProducts[comingFrom + 'Products'];
                var date = new Date();
                var TodaysDate = new Date();
                let ADD_DAYS = 183;
                date.setDate(date.getDate() + ADD_DAYS);
                calculateAutoshipData = {
                    ...calculateAutoshipData,
                    startDate: FILTER_PRODUCTS?.find(row => row?.title === 'Ambassador Registration Fee') ? moment(TodaysDate).add(1, 'y').utc().format() : moment(date).utc().format(),
                    frequencyType: 2,
                    priceType: _priceTypeForCalculate('ambassador', autoshipProduct),
                    recurringOrderType: 3,
                    details: _productPayload([AmbassadorRenewalProducts]),
                    Payments: [{ ...membershipPayload, "maxAmount": isOrderTotalZero ? 0 : AmbassadorRenewalProducts?.normal_autoship, }],
                    customerId: localStorageCall().getItem('Token') || 0,
                    // Payments: []
                };
                dispatch(CreateAutoshipOrderApi(calculateAutoshipData, null, orderid,
                    autoshipProduct?.length > 0 && !isOrderTotalZero
                        ?
                        () => {
                            // calculateAutoshipData['recurringOrderType'] = 1;
                            if ((Action === 'smartsave') || (oneTimeToAutoship === 'true')) {
                                callBackAutoshipFunction(autoshipProduct, values, orderid, false, null, {
                                    ...userDetails, ...formData, ...Dates, selectedLanguage: selectedLanguage,
                                }, null, autoShipToken, accountId)
                            }
                            else {
                                callBackAutoshipFunction(autoshipProduct, values, orderid, null, null, null, 'membership', autoShipToken, accountId)
                            }
                        }
                        :
                        null
                ))
                // } else {
                //     let membershipPayload = _paymentPayload(null, values, 'autoship', selectedPayment);

                //     if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                //         console.log("inside-the-if-condition-----------------sss")
                //         membershipPayload = {
                //             ...membershipPayload,
                //             saveToken: false,
                //             token: selectedPayment?.cardValue?.token,
                //             customerAccountId: selectedPayment?.cardValue?.customerAccountId,
                //             recurringPaymentActionType: 0
                //         }
                //         _membershipApiCall(orderid, values, autoshipProduct, membershipPayload, autoShipToken, accountId)
                //         // }
                //         // else {
                //         // if (selectedPayment?.selectedOptionForPayment === 1) {
                //         //     setOnSelectedCardError('Please select your payment method.');
                //         //     _setTimeOut(() => setOnSelectedCardError(''), 3000);
                //     } else {

                //         console.log("inside-the-else-condition-----------------sss")

                //         // _scriptFunctionCall(paymentFormHtml, () => {
                //         setCheckoutProcessing(true)
                //         // loopFunction(paymentFormHtml, ({ tokenId, preAuthOrderId }) => {
                //         membershipPayload["token"] = selectedPayment?.cardValue?.token || autoShipToken;
                //         membershipPayload['customerAccountId'] = selectedPayment?.cardValue?.customerAccountId || accountId;
                //         membershipPayload['saveToken'] = (autoshipProduct?.length > 0) ? true : savedThisCard?.checked;
                //         membershipPayload['recurringPaymentActionType'] = 0;
                //         _membershipApiCall(orderid, values, autoshipProduct, membershipPayload, autoShipToken, accountId)
                //         // })
                //         // }, membershipPayload);

                //     }
                // }
                // }
            } catch (err) {
                console.log(err, 'dddddddddddddddddddddddd')
            }
        }


        function _withoutLoginUserCreate(formData, loginToken, callback, autoshipProduct, oldUserData) {
            var TodaysDate = new Date();

            if (formData?.shipping_email && !loginToken) {
                const formDataValues = {
                    email: formData?.shipping_email,
                    firstName: formData?.shipping_urname,
                    lastName: formData?.shipping_lastname,
                    country: formData?.shipping_country,
                    state: formData?.shipping_state,
                    city: formData?.shipping_city,
                    selectedLanguage: selectedLanguage,
                    // membershipRenewalDate: SINGLE_MEMBERSHIPCHECK || MEMBERSHIP_AVAILABLE ?
                    //     moment(oldUserData?.membershipRenewalDate ? oldUserData?.membershipRenewalDate : TodaysDate).add(1, 'y').utc().format()
                    //     : "",
                    ...formData
                }
                const USER_DETAILS = userDetails?.firstName ? userDetails : _formDefaultFormat(userData, formData)
                if (!oldUserData) {
                    console.log("inside-the-olderuderdata====================")
                    dispatch(SignUpFormApi(formDataValues, 'lead', (data, id) => {
                        if (callback) {
                            localStorageCall().setItem('Token', id);
                            if (SINGLE_MEMBERSHIPCHECK && _.upperCase(storeAssigned()) === 'JP') {
                                dispatch(_addGNumberIdentifier(id, formData?.gNumber, () => callback(data, id), setCheckoutProcessing));
                            } else {
                                callback(data, id)
                            }
                        } else {
                            dispatch(CreateOrderApi({ ...calculteDataUser, customerId: +id }, autoshipProduct, (orderid, autoShipToken, accountId) => {
                                if (!MEMBERSHIP_AVAILABLE) {
                                    callBackAutoshipFunction(autoshipProduct, { ...formData, customerId: +id, selectedLanguage: selectedLanguage }, orderid, false, null, null, null, autoShipToken, accountId)
                                } else {
                                    _membershipApiCall(orderid, { ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage, }, autoshipProduct, null, autoShipToken, accountId);
                                }
                            }, { ...formDataValues, ...Dates }, SINGLE_MEMBERSHIPCHECK ? 'ambassador' : MEMBERSHIP_AVAILABLE ? 'member' : 'member', setCheckoutProcessing, rankUpgrad, isOrderTotalZero))
                        }
                    }, setCheckoutProcessing))
                } else {
                    console.log("inside-the-elsedatat====================")
                    localStorageCall().setItem('Token', +oldUserData?.[0]?.customerId);
                    dispatch(CreateOrderApi({ ...calculteDataUser, customerId: +oldUserData?.[0]?.customerId }, autoshipProduct, (orderid, autoShipToken, accountId) => {
                        if (!MEMBERSHIP_AVAILABLE) {
                            callBackAutoshipFunction(autoshipProduct, { ...formData, customerId: +oldUserData?.[0]?.customerId, selectedLanguage: selectedLanguage }, orderid, false, null, null, null, autoShipToken, accountId)
                        } else {
                            _membershipApiCall(orderid, { ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage, }, autoshipProduct, null, autoShipToken, accountId);
                        }
                    }, { ...formDataValues, ...Dates }, SINGLE_MEMBERSHIPCHECK ? 'ambassador' : 'member', setCheckoutProcessing, rankUpgrad, isOrderTotalZero))
                }
            }
        }

        //checkout processing loader
        const [checkoutProccessing, setCheckoutProcessing] = useState(false);

        function _callATokenScript(values, actions, checkoutPayload, calculteDataUser, autoshipProduct, oldUserData) {

            console.log("autoshipProduct?.length > 000000000000000", autoshipProduct?.length, selectedPayment?.cardValue?.token)

            const POINT_DISCOUNT = usePoint?.wantToUSePoint && usePoint?.paymentObject?.maxAmount ? [usePoint?.paymentObject] : [];
            const POINT_AMOUNT = usePoint?.wantToUSePoint && usePoint?.paymentObject?.maxAmount ? usePoint?.paymentObject?.maxAmount : 0;
            calculteDataUser['Payments'] = [{
                ...checkoutPayload, "maxAmount": parseFloat(+calculatedData?.oneTimeCalculateData?.orderTotal - POINT_AMOUNT).toFixed(2),
            }, ...POINT_DISCOUNT];

            if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                calculteDataUser = {
                    ...calculteDataUser,
                    Payments: [{
                        ...checkoutPayload,
                        token: selectedPayment?.cardValue?.token,
                        customerAccountId: selectedPayment?.cardValue?.customerAccountId,
                        "maxAmount": parseFloat(+calculatedData?.oneTimeCalculateData?.orderTotal - POINT_AMOUNT).toFixed(2),
                    }, ...POINT_DISCOUNT]
                }
            }
            updatePaymentCallbackSession(calculteDataUser?.customerId);
            _scriptFunctionCall(calculteDataUser, 'normal', {
                onRequestStart: () => setCheckoutProcessing(true),
                onSuccess: ({ tokenId, orderId, preAuthOrderId }) => {
                    checkoutPayload["token"] = tokenId;
                    checkoutPayload['saveToken'] = (autoshipProduct?.length > 0) ? true : savedThisCard?.checked;
                    _onHandleSubmit({ ...values, customerId: calculteDataUser?.customerId }, checkoutPayload, orderId, actions, oldUserData, preAuthOrderId);
                },
                onError: (err) => {
                    setCheckoutProcessing(false);
                    const errorPayment = err?.errorPayment ?? err?.response ?? err;
                    setScriptError(typeof errorPayment === 'string' ? errorPayment : JSON.stringify(errorPayment));
                    if (actions) {
                        actions.setSubmitting(false);
                    }
                },
            });
        }

        const _onHandleSubmit = async (values, simplecheckoutPayload = null, orderId = 0, actions, oldUserData, preAuthOrderId = 0) => {
            console.log(formData, "formDataaaaaaaaaaaaaaattttttttttaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
            setCheckoutProcessing(true);
            const loginToken = localStorageCall().getSingleItem('Token')
            const FILTER_PRODUCTS = addToCartProducts[comingFrom + 'Products'];
            // const detailsArray = _productPayload(FILTER_PRODUCTS);
            const detailsArray = (Action === 'smartsave') || (oneTimeToAutoship === 'true') ? _productPayload(_.filter(FILTER_PRODUCTS, ({ frequency }) => (frequency === "oneTime" || frequency === "member"))) : _productPayload(FILTER_PRODUCTS);
            const autoshipProduct = _productPayload(_.filter(FILTER_PRODUCTS, ({ frequency }) => (frequency === "autoship")));
            let checkoutPayload = _paymentPayload(null, values, 'normal', selectedPayment, paymentOption_ID);
            checkoutPayload['saveToken'] = (paymentOption_ID?.paymentOptionTypeDescription === 'Offline') ? false : (autoshipProduct?.length > 0) ? true : savedThisCard?.checked;
            calculteDataUser["details"] = detailsArray?.length > 0 && detailsArray;
            calculteDataUser['priceType'] = _priceTypeForCalculate(rankUpgrad, couponCode?.valid ? [] : autoshipProduct);
            calculteDataUser['Payments'] = [{ ...checkoutPayload, "maxAmount": +calculatedData?.oneTimeCalculateData?.orderTotal }];
            console.log("calculteDataUser", calculteDataUser)
            calculteDataUser['orderId'] = +orderId;
            calculteDataUser['preAuthOrderId'] = +preAuthOrderId;
            // calculteDataUser['Offline'] = paymentOption_ID?.paymentOptionTypeDescription === 'Offline' ? true : false
            calculteDataUser['customerId'] = calculteDataUser?.['customerId'] || values?.customerId;
            calculteDataUser['couponCodes'] = couponCode?.code ? [couponCode.code.trim()] : [];
            console.log("simplecheckoutPayload", simplecheckoutPayload, "preAuthOrderId", preAuthOrderId, "selectedPayment", selectedPayment);
            console.log("checkoutPayload", checkoutPayload)
            if (simplecheckoutPayload?.token || orderId || preAuthOrderId || isOrderTotalZero
                //  || paymentOption_ID?.paymentOptionTypeDescription === 'Offline'
            ) {
                console.log(1)
                if (detailsArray?.length > 0) {
                    console.log(2)
                    const POINT_DISCOUNT = usePoint?.wantToUSePoint && usePoint?.paymentObject?.maxAmount ? [usePoint?.paymentObject] : [];
                    const POINT_AMOUNT = usePoint?.wantToUSePoint && usePoint?.paymentObject?.maxAmount ? usePoint?.paymentObject?.maxAmount : 0;

                    calculteDataUser['Payments'] = [{
                        ...(paymentOption_ID?.paymentOptionTypeDescription === 'Offline' ? checkoutPayload : simplecheckoutPayload),
                        // ...simplecheckoutPayload,
                        "maxAmount": parseFloat(+calculatedData?.oneTimeCalculateData?.orderTotal - POINT_AMOUNT).toFixed(2),
                    }, ...POINT_DISCOUNT];

                    const REMAIN_ONETIME = _.filter(detailsArray, ({ itemId }) => (itemId !== MEMBERSHIP_AVAILABLE?.id))?.length > 0;
                    var date = new Date();
                    var TodaysDate = new Date();
                    date.setDate(date.getDate() + 183);
                    const trimmedCode = couponCode.code.trim();
                    calculteDataUser['couponCodes'] = couponCode?.code ? [trimmedCode] : [];
                    let VALUE = _.flatMap(_.map(autoShipOrders, (row) => row?.details));

                    const FILTER_PRODUCTS = addToCartProducts[comingFrom + 'Products'];
                    const FIND_OLD_PRODUCT = _.find(VALUE, (row) => row?.title === "Ambassador Registration Fee");
                    const FIND_PRODUCT = _.find(VALUE, (row) => row?.title === "Ambassador Registration Fee");
                    const memberProduct = _.find(autoShipOrders, row => row?.recurringOrderId === FIND_PRODUCT?.recurringOrderId)
                    const memberOldProduct = _.find(autoShipOrders, row => row?.recurringOrderId === FIND_OLD_PRODUCT?.recurringOrderId)
                    const AUTOSHIP_PRODUCTS = FILTER_PRODUCTS?.find(row => row?.title === 'Ambassador Registration Fee') && memberProduct ? _productPayload([FIND_PRODUCT]) : (MEMBERSHIP_AVAILABLE && _.upperCase(storeAssigned()) !== 'JP') || (MEMBERSHIP_AVAILABLE && REMAIN_ONETIME && _.upperCase(storeAssigned()) !== 'JP') ? [...autoshipProduct, ..._productPayload([MEMBERSHIP_AVAILABLE])] : autoshipProduct;

                    if (!loginToken) {
                        console.log(3)
                        _withoutLoginUserCreate(formData, loginToken, (data, id) => _onHandleSubmit({ ...values, customerId: id }, checkoutPayload, null, actions), AUTOSHIP_PRODUCTS, oldUserData);
                    } else {
                        console.log(4)
                        const USER_DETAILS = userDetails?.firstName ? userDetails : _formDefaultFormat(userData, formData)
                        dispatch(CreateOrderApi(calculteDataUser, AUTOSHIP_PRODUCTS, (orderid, autoShipToken, accountId) => {
                            if (!MEMBERSHIP_AVAILABLE) {
                                if ((Action === 'smartsave') || (oneTimeToAutoship === 'true')) {
                                    callBackAutoshipFunction(AUTOSHIP_PRODUCTS, { ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage, }, orderid, false, null, null, null, autoShipToken, accountId)
                                } else {
                                    callBackAutoshipFunction(autoshipProduct, { ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage, }, orderid, false, null, null, null, autoShipToken, accountId)
                                }
                            } else {
                                _membershipApiCall(orderid, { ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage, }, autoshipProduct, null, autoShipToken, accountId);
                            }
                            // }

                        }, {
                            ...USER_DETAILS, ...formData, ...Dates, selectedLanguage: selectedLanguage,
                            // membershipRenewalDate: memberProduct ? moment(userData?.membershipRenewalDate).add(1, 'y').utc().format() : (MEMBERSHIP_AVAILABLE) || (MEMBERSHIP_AVAILABLE && REMAIN_ONETIME) ?
                            //     FILTER_PRODUCTS?.find(row => row?.title === 'Ambassador Registration Fee') ?
                            //         moment(userData?.membershipRenewalDate ? userData?.membershipRenewalDate : TodaysDate).add(1, 'y').utc().format()
                            //         : "" : "",
                        }, SINGLE_MEMBERSHIPCHECK ? 'ambassador' : MEMBERSHIP_AVAILABLE ? 'member' : 'member', setCheckoutProcessing, rankUpgrad, isOrderTotalZero))
                    }
                } else {
                    console.log(5)
                    callBackAutoshipFunction(autoshipProduct, values, null)
                }

            } else {
                if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                    console.log("7666666666666666666666", 6)
                    checkoutPayload = {
                        ...checkoutPayload,
                        saveToken: false,
                        token: selectedPayment?.cardValue?.token,
                        customerAccountId: selectedPayment?.cardValue?.customerAccountId
                    }
                }
                // if (selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1) {
                //     console.log("7666666666666666666666", 6)
                //     checkoutPayload = {
                //         ...checkoutPayload,
                //         saveToken: false,
                //         token: selectedPayment?.cardValue?.token,
                //         customerAccountId: selectedPayment?.cardValue?.customerAccountId
                //     }
                //     _onHandleSubmit(values, checkoutPayload, 0, actions);
                // } else {
                console.log(7)
                // if (selectedPayment?.selectedOptionForPayment === 1) {
                //     console.log(8)
                //     setOnSelectedCardError('Please select your payment method.');
                //     _setTimeOut(() => setOnSelectedCardError(''), 3000);
                // } else {
                console.log(9)
                if (!loginToken
                    //  && paymentOption_ID?.paymentOptionTypeDescription === 'Redirect'
                ) {
                    console.log(10)
                    _withoutLoginUserCreate(formData, loginToken, (data, id) => {
                        console.log(id, 'Token')
                        _callATokenScript(values, actions, checkoutPayload, { ...calculteDataUser, customerId: +id }, autoshipProduct, oldUserData);
                    }, autoshipProduct)
                } else {
                    console.log(11)
                    if (SINGLE_MEMBERSHIPCHECK && _.upperCase(storeAssigned()) === 'JP') {
                        dispatch(_addGNumberIdentifier(loginToken, formData?.gNumber, () => _callATokenScript(values, actions, checkoutPayload, calculteDataUser, autoshipProduct, oldUserData), setCheckoutProcessing));
                    } else {
                        _callATokenScript(values, actions, checkoutPayload, calculteDataUser, autoshipProduct, oldUserData);
                    }
                }

                // }
                // }
            }
        };

        const subTotal = useMemo(() => {
            if (addToCartProducts['normalProducts']?.length > 0) {
                return ({
                    productCount: _.map(addToCartProducts['normalProducts'], 'quantity').reduce((prv, next) => prv + next),
                    productSubTotal: _.map(addToCartProducts['normalProducts'], (row) => (row['normal' + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)]) * +row?.quantity).reduce((prv, next) => prv + next),
                    productCVValue: _.map(addToCartProducts['normalProducts'], (row) => (row['cv' + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)]) * +row?.quantity).reduce((prv, next) => prv + next),
                })
            }
        }, [addToCartProducts['normalProducts']]);

        return <Component {...props} {...{
            isUserLogin, error, cashPayNote, loginSliceloading, loginErrorMsg, customerSliceLoading, CURRUNT_ROLE, formData, setFormData, selectedPayment, setSelectedPayment, customerSliceError, paymentError,
            savedCards, savedThisCard, setSavedThisCard, usePoint, setUsePoint, onSelectedCardError, setOnSelectedCardError,
            otp, setOtp, otpPopUp, setOtpPopUp, countryState, setCountryState, shippingMethods, selectedShippingOption, calculatedData,
            paymentOptions, paymentFormHtml, userDetails, setUserDetails, checkValidUser, navigate, ROUTING_TEXT, isLoading,
            useDefaultAddressOrNot, setUseDefaultAddressOrNot, userData, errorAddressData, couponCode, setCouponCode, couponErrorData,
            paymentOption_ID, iframeLoader, sameAsBillingChecked, setSameAsBillingChecked, shippingLoading, referralerror,

            _handleShippingChange, handleChangeFunction: calculateNormalOrder, handleChangeValidate, _createMarchentProfile,
            _paymentOptionSetBilling, handleButtonClick, currentStep, _handleFormSubmit,

            _productPayload, dispatch, _authenticateOtp, _onHandleSubmit, _handleCardChange, normalAddressError,
            _setUseDefaultAddressFunction, _handelGooglePlace, _acceptOrNotAddressOption, calculateApiLoading, _otpResend, resentStatus,
            storeToken, smartSaveSchedule, setSmartSaveSchedule, _handleDLocalPopup, askPopupDLocal, setAskPopupDLocal,
            _onCouponClick, subTotal, orders, checkoutProccessing, selectedLanguage, setSelectedLanguage, SINGLE_MEMBERSHIPCHECK, MEMBERSHIP_AVAILABLE,
            setScriptError, scriptError, taxTypeData, gNumberErrorMsg, isOrderTotalZero, countryData
        }} />
    })

    return WithCheckoutHOComponent;
}

export default withCheckoutHOC;